const API_BASE = import.meta.env.VITE_API_BASE ?? "/api";

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...init?.headers },
    ...init,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new ApiError(res.status, data.error ?? data.message ?? "Request failed");
  }
  return data as T;
}

export const api = {
  me: () => request<{ authenticated: boolean; email?: string }>("/auth/me"),
  magicLink: (email: string) =>
    request<{ ok: boolean; message: string }>("/auth/magic-link", {
      method: "POST",
      body: JSON.stringify({ email }),
    }),
  logout: () => request<{ ok: boolean }>("/auth/logout", { method: "POST" }),
  startUpload: (files: { filename: string; size: number; content_type: string }[]) =>
    request<{
      upload_id: string;
      items: {
        item_id: string;
        filename: string;
        signed_put_url: string;
        put_headers: Record<string, string>;
      }[];
    }>("/uploads/start", { method: "POST", body: JSON.stringify({ files }) }),
  finishUpload: (
    uploadId: string,
    payload: {
      files: {
        original_filename?: string;
        filename: string;
        size: number;
        content_type: string;
      }[];
      note?: string;
    },
  ) =>
    request<{ ok: boolean; upload_id: string; file_count: number; gcs_prefix: string }>(
      `/uploads/${uploadId}/finish`,
      { method: "POST", body: JSON.stringify(payload) },
    ),
};
